var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('img',{attrs:{"alt":"Vue logo","src":require("./assets/gig.jpg")}}),_c('div',{staticClass:"contents"},[_c('router-view'),_c('router-link',{attrs:{"to":"/logout"}},[_vm._v("logout")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }